// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pTHu","type":"styles_type__3mzjk","choices":"styles_choices__3kx_n"};